
<!--====== Banar Start here======-->



<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <!-- "> md" -->
                <img src="../../../assets/images/banners/retail-bannarimage.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="ratail banner" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/retail-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="retail mobile" />

                <!-- <img src="../../../assets/images/banners/mitbannername.png"
                    alt="Banner-mit" class="img-responsive w-100 h-100"> -->
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content">
                                <span>Retail</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span>Drive value, enhance patient experience with cutting-edge retail
                                        technology.</span>
                            </div>
                            <div class="col pt-lg-3 pt-3 mt-lg-3">

                            <a href="contact" class="global_button   text-left col text-white white_button">
                                <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow white" /></div>
                                GET IN TOUCH </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>


<!--====== Banar end here ======-->

<!--====== Retail Technology  start  ======-->
<div class="retail_mainsection">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12 col-sm-12"></div>
        <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-6">
            <img src="../../../assets/images/retail_images/retail-imagemain.png"
                class="w-100 h-100 retail_mainimage" alt="retail main" />
        </div>
        <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-6a">
            <div class="pt-5 retail">
                <div class="global_section_header text-black retail_subcontent mt-4">Retail Technology </div>
                <div class=" retail_itsubcontenttext pt-5 global_section_content text-black ">
                    The world is now shifting to digital, and if you don't shift your business from bricks to clicks,
                    you are steadily pushing it towards a dormant corner. Whether you have a business in grocery,
                    apparel, electronics or beauty, we help you reach the greatest number of potential customers with
                    the help of Maganti IT retail software solutions. We can help your business get the genuine push it
                    needs by creating customized retail web portals and mobile apps- while building customer base and
                    enhancing patient experience.
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
<!--======Retail Technology End ======-->

<!--====== retail New Service Offerings Start ======-->
<div class="feature-large-images-wrapper pt-5 finance_mainbgimage">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_30">
                    <h3 class="section-sub-title mb-20 global_section_header pt-5">Agile Retail technology methodology
                    </h3>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row small-mt__30">
                    <div class="col-lg-3 col-md-6 mt-30">
                        <div  class="box-large-image__two finance_itdesignbgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/digital.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail digital" />
                                </div>

                                <div class="box-info ">
                                    <div class="heading sixthheading">Digital and Analytics </div>
                                    <div class="box-more-info">
                                        <div class="text">Design and build key platform components of our customers’
                                            Digital-Technology powering their Digital transformation journeys. </div>

                                    </div>
                                </div>
                            </div>
                    </div>
                    </div>


                    <div class="col-lg-6 col-md-6  mt-30">
                        <div class="box-large-image__two finance_itmanagementbgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/iot.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail iot" />
                                </div>

                                <div class="box-info">
                                    <div class="heading sixthheading">IoT </div>
                                    <div class="box-more-info">
                                        <div class="text">At IoT we help create entirely new services, delivering
                                            measurable business outcomes thereby differentiating enterprises and helping
                                            them become a 21st Century Enterprise .
                                        </div>
                                    </div>
                                </div>
                            </div>
                     </div>
                    </div>

                    <div class="col-lg-3 col-md-6 mt-30">
                        <div  class="box-large-image__two finance_datasecuritybgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/application.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail application" />
                                </div>
                                <div class="box-info">
                                    <div class="heading sixthheading">Application Services </div>
                                    <div class="box-more-info">
                                        <div class="text">Full lifecycle of systems integration consulting services
                                            ensuring a unified approach to developing the right solutions for their
                                            business needs .
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 mt-30">
                        <div class="box-large-image__two finance_businessreformbgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/infrastuture.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail infra" />
                                </div>
                                <div class="box-info">
                                    <div class="heading sixthheading">Infrastructure Services </div>
                                    <div class="box-more-info">
                                        <div class="text">Our IT Infrastructure services have helped the client
                                            implement centralized monitoring and create a flawless infrastructure
                                            monitoring interface. 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6 mt-30">
                        <div class="box-large-image__two finance_infrastructurebgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/enginner.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail engg" />
                                </div>
                                <div class="box-info">
                                    <div class="heading sixthheading">Engineering and R&D services </div>
                                    <div class="box-more-info">
                                        <div class="text">We execute from the product blueprinting to support, from
                                            software or hardware to mechanical. 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="col-lg-4 col-md-6 mt-30">
                        <!-- Box large image warap Start -->
                        <div class="box-large-image__two finance_firewellbgimage">
                            <div class="box-large-image__two__box">
                                <div class="box-large-image__midea">
                                    <img src="../../../assets/images/retail_images/operation.png"
                                        class="single-gallery__thum bg-item-images bg-img" alt="retail operation" />
                                </div>

                                <div class="box-info">
                                    <div class="heading sixthheading">Digital Process Operations </div>
                                    <div class="box-more-info">
                                        <div class="text">Reimagine the role of technology from being a driver of
                                            marginal efficiency to an enabler of digital innovation and fueling business
                                            performance. </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Box large image warap End -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<!--====== retail New Service Offerings End ======-->

<!--====== retail it solutions end here ======-->
<div class="feature-icon-wrapper  benefits_bgimage section-space--pt_100 section-space--pb_70 mt-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_20">
                    <h3 class="manufacture-heading global_section_header">Retail IT solutions </h3>
                    <p class="global_sub_title vision-content-section">From a plethora of new products, markets, and customer segments to the burgeoning expansion of
                        sales and marketing channels (like mobile and social commerce), retail is at a tipping point. We
                        help transform your retail experience and ensure better flexibility. </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="feature-list__three">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fa-solid fa-shield"></i> -->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-shield-check" viewBox="0 0 16 16">
                                                    <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
                                                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
                                                  </svg>
                                            </div>
                                            <div class="heading global_sub_title1 fifthheading">
                                                <b>Retail Connect</b>
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Modern technological innovations in mobility, such as NFC,
                                                coupons/payment, geo-fencing alerts, etc.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fal fa-lock-alt"></i> -->
                                                <i class="fa-solid fa-lock"></i>
                                            </div>
                                            <div class="heading global_sub_title fifthheading">
                                                <b>Food Safety And Traceability</b>
</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Our Track and Trace solution ensures compliance with food
                                                safety regulations by providing complete visibility of the supply chain.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fal fa-magnet"></i> -->
                                                <i class="fa-solid fa-magnet"></i>
                                            </div>
                                            <div class="heading global_sub_title fifthheading">
                                                <b>Portfolio Optimisation</b>
</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Analyze your competencies and gain insights across the IT
                                                landscape and business value chain to make informed decisions.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fal fa-medal"></i>
                                             -->
                                             <i class="fa-solid fa-medal"></i>

                                            </div>
                                            <div class="heading global_sub_title fifthheading">
                                                <b>Retail Enterprise Collaboration</b>
</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Improve communication quality, collaboration speed, and
                                                employee engagement .</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fal fa-magnet"></i> -->
                                                <i class="fa-solid fa-magnet"></i>

                                            </div>
                                            <div class="heading global_sub_title fifthheading">
                                                <b>Integrated Retail Planning</b>
</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">The Integrated Retail Planning framework assists you in
                                                aligning your supply chain and merchandise strategy with long-term
                                                business strategies.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <!-- <i class="fal fa-medal"></i> -->
                                                <i class="fa-solid fa-medal"></i>

                                            </div>
                                            <div class="heading global_sub_title fifthheading">
                                                <b>Dashboard</b>
</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Real-time IT and business monitoring that provides
                                                actionable insights </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ====== retail Service Offerings End ======-->








<!--======= Casestudy section End =======-->
<div class="casestudy-layoutsection pt-lg-5">
    <div class=" container-fluid p-0">
        <div class="row">
            <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8">
                <div class="casestudy_headder global_section_header my-3 mt-lg-5">Client Success Stories</div>
                <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-5">

                    Learn how we’re helping our clients take the big move with technology and the difference they make
                    across the globe.
                </div>
            </div>
        </div>

        <!------------------Carousel section starts------>
        <div id="main-wrapper">
            <div class="site-wrapper-reveal">
                <div class="flexible-image-slider-wrapper">
                    <div class="container-fluid p-0">
                        <div class="row m-0">
                            <div class="col-lg-12 p-0">
                                <div class="flexible-image-slider-wrap">
                                    <swiper-container  id="homeCaseStudySwiper" class=" single-flexible__container"  slides-per-view="1"  navigation="true" loop="true">

                                            <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/caseStudyStory.png"
                                                        alt="casestudy button" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-down">
                                                        <div class="row mx-0 h-75 supercharge">
                                                            <div class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100 "
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd); height: 100% !important;">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Supercharge with Cloud and Automation</p>
                                                                        <p
                                                                            class="text-white  casestudy-content-section">
                                                                            FUTEK, a leading sensor technology giant
                                                                            takes the leap to cloud for a major IT
                                                                            transformation and innovation.
                                                                        </p>
                                                                        <a href="/futek-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- Single flexible slider End -->
                                                </swiper-slide>
                                                <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/casestudy-ouropinions-image.png"
                                                        alt="our opinions" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-up">
                                                        <div class="row mx-0 h-75  supercharge ">
                                                            <div
                                                                class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100"
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Helping exchange social perspectives in a
                                                                            seamless way </p>
                                                                        <p
                                                                            class="text-white   casestudy-content-section">
                                                                            Learn how we built a futuristic application
                                                                            and incorporated future cloud advances into
                                                                            our client’s IT infrastructure.
                                                                        </p>
                                                                        <a href="/ouropinion-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                                <!-- Single flexible slider End -->
                                            </swiper-slide>

                                     
                                    </swiper-container >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!------------------Carousel section Ends------>
            <div class="industry-button text-center py-3 py-md-5">
                <!-- <a href="case-studies" class="global_button">VIEW ALL<i class="fas fa-arrow-right"></i></a> -->
                <a href="/case-studies" class="global_button d-none d-lg-inline-block text-left col ">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow black" /></div>
                      VIEW ALL
                </a>
            </div>
        </div>
    </div>
</div>
<!--======= Casestudy section Ends =======-->


<!--======= Insights section Start =======-->
<div class="layouts-section-wrap">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 offset-sm-2 col-sm-8">
                <div class="pt-md-5" data-aos="fade-up">
                    <div class="insight-title global_section_header">
                        Insights
                        <!-- <a href=""></a> -->
                    </div>
                    <div class="insight-subtitle global_sub_title vision-content-section mt-3">
                        <span>
                            Explore insights and inspiration to unlock innovation, build trust, and engineer advantage
                            for your digital journey.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container-fluid">

        <div class="-row d-lg-none pt-lg-4">
            <div class="px-4 -col-lg-12">
                <div class="flexible-image-slider-wrap">

                    <swiper-container 
                    class="single-flexible__container " 
                    slides-per-view="1" 
                    autoplay="true" 
                    loop="true" 
                    navigation="true" 
                    pagination="true">
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider1.png" class="img img-responsive w-100 h-100" alt="firstslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>The Future of Marketing Personalization: AI-Powered Journeys</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                            <div>Across the entire customer journey, AI is assisting marketers in providing more helpful, enjoyable experiences for shoppers and improving performance. Find how retail stores can capitalize on this technology trend.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="personalize-and-machine-learning" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="insight arrow" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider2.png" class="img img-responsive w-100 h-100" alt="secondslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Embracing the next era of Digital: From Survival, Thriving to Reinvigorating</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Learn how businesses have progressed into the digital post-pandemic era and how far they can go to adapt to the changing customer mindset.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="/postpandamic" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="casestudy button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider3.png" class="img img-responsive w-100 h-100" alt="thirdslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Increase software adoption and knowledge retention while making a positive impact on the working lives of your employees.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="migrate-cloud" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                  </swiper-container>
                  
                </div>
            </div>
        </div>
      
        <div class="" >
            <app-insightsslider></app-insightsslider>
          </div>

    </div>
</div>
<!--======= Insights section Ends =======-->


